import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconShowFooterbar } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { closeOverflowMenuIfOpen } from '../../actions.web';
import { showToolbox, hideToolbox } from '../../actions';
/**
 * Implementation of a button for toggling fullscreen state.
 */
class ToggleFooterToolbar extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.showFooterbar';
        this.toggledAccessibilityLabel = 'toolbar.accessibilityLabel.exitFullScreen';
        this.label = 'toolbar.showFooterbar';
        // toggledLabel = 'toolbar.hideFooterbar';
        this.tooltip = 'toolbar.showFooterbar';
        // toggledTooltip = 'toolbar.hideFooterbar';
        this.toggledIcon = IconShowFooterbar;
        this.icon = IconShowFooterbar;
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._toolboxVisible;
    }
    /**
    * Handles clicking the button, and toggles fullscreen.
    *
    * @private
    * @returns {void}
    */
    _handleClick() {
        const { dispatch, _toolboxVisible } = this.props;
        // sendAnalytics(createToolbarEvent(
        //     'toggle.fullscreen',
        //     {
        //         enable: !_fullScreen
        //     }));
        dispatch(closeOverflowMenuIfOpen());
        if (!_toolboxVisible) {
            dispatch(showToolbox());
        }
        else {
            dispatch(hideToolbox(true));
        }
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    const { visible } = state['features/toolbox'];
    return {
        //visible: !isIosMobileBrowser(),
        //It is required to show the button on IosBrowser
        visible: true,
        _toolboxVisible: visible
    };
};
export default translate(connect(mapStateToProps)(ToggleFooterToolbar));
